<template>
  <div>
    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
      Tipo de orden
    </label>
    <div class="space-y-2">
      <div
        class="flex items-center p-3 border rounded-lg cursor-pointer transition-colors"
        :class="selectedItemType === 'dine_in' ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20' : 'border-gray-300 dark:border-gray-700'"
        @click="$emit('select-type', 'dine_in')"
      >
        <div class="flex items-center mr-3">
          <div
            class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
            :class="selectedItemType === 'dine_in' ? 'border-indigo-600 bg-indigo-600' : 'border-gray-300 dark:border-gray-600'"
          >
            <div
              v-if="selectedItemType === 'dine_in'"
              class="w-2 h-2 rounded-full bg-white"
            />
          </div>
        </div>
        <div class="flex-1">
          <p class="font-medium text-gray-900 dark:text-gray-100">
            Comer aquí
          </p>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Servicio a mesa
          </p>
        </div>
      </div>
      
      <div
        class="flex items-center p-3 border rounded-lg cursor-pointer transition-colors"
        :class="selectedItemType === 'takeaway' ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-900/20' : 'border-gray-300 dark:border-gray-700'"
        @click="$emit('select-type', 'takeaway')"
      >
        <div class="flex items-center mr-3">
          <div
            class="w-5 h-5 rounded-full border-2 flex items-center justify-center"
            :class="selectedItemType === 'takeaway' ? 'border-indigo-600 bg-indigo-600' : 'border-gray-300 dark:border-gray-600'"
          >
            <div
              v-if="selectedItemType === 'takeaway'"
              class="w-2 h-2 rounded-full bg-white"
            />
          </div>
        </div>
        <div class="flex-1">
          <p class="font-medium text-gray-900 dark:text-gray-100">
            Para llevar
          </p>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Empacar para llevar
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  selectedItemType: 'dine_in' | 'takeaway';
}

defineProps<Props>();

defineEmits<{
  'select-type': [type: 'dine_in' | 'takeaway'];
}>();
</script>
